import React from 'react';
import Body from '../Components/layout/Body';

//content sub-component with unique content for this page
function StaticPrivacyContent(props) {
  return(
    <>
    <div>
      <p>
        We respect and are committed to protecting your privacy. This Privacy Policy lets you know how your information is processed and used. Your continued use of Access Navigator constitutes your acceptance and agreement to this Policy and any updates. If you have questions about this policy, please feel free to contact us at accessnavigator@aac-learning-center.org.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>Why we store data</h4>
      <p>
        Access Navigator stores data for your convenience, so you can resume an assessment at a later date, review information any time in the future, or share it with appropriate individuals at any time.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>What we store</h4>
      <p>
        The Access Navigator app stores data entered or recorded during its use. These data include:
      </p>
      <ol>
        <li>Practitioner information:
          <ul>
            <li>Name and email address -- these are optional entries for practitioners who create an Access Navigator account.</li>
            <li>An account is not necessary for using Access Navigator.</li>
          </ul>
        </li>
        <li>Client information:
          <ul>
            <li>Identifier label for client (the individual who needs alternative access)</li>
            <li>Data entered during assessment with Access Navigator, such as answers to questions in the app, and speed and accuracy information (e.g., typing speed) when in-app activities are part of the assessment.</li>
          </ul>
        </li>
      </ol>
      <p>
        The client information may be personally identifiable if you provide an actual first and last name for the client. However, Access Navigator does not require you to provide personally identifiable client information.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>Where we store data</h4>
      <strong>Mode 1. Logged in to Access Navigator account</strong>
      <p>
        When logged in to an Access Navigator account, data are stored locally on your device, within the browser's local storage and IndexedDB database. If an internet connection is active, the local database will regularly synch with a remote database hosted by MongoDB Atlas. For remote data stored on central servers, we take reasonable steps to secure your personally identifiable information against unauthorized access or disclosure. We encrypt login credentials and email addresses (if provided). However, no security or encryption method can be guaranteed to protect information from hackers or human error.
      </p>
      <strong>Mode 2. NOT logged in</strong>
      <p>
        When not logged in to an Access Navigator account, data are only stored locally on your device, within the browser's local storage and IndexedDB database. In theory, these local data remain available until you clear your browser data, but in practice, the browser may erase these data under various conditions. If you want a more reliable location for data storage, you can create a user account.
      </p>
      <strong>Mode 3. Special mode with NO data storage</strong>
      <p>
        If necessary, it is also possible to run Access Navigator such that no data at all are stored, either locally or remotely. To do this, enter https://accessnavigator.org/?studyParticipant=PXXXXCyyyy into the browser, filling in XXXX and yyyy with 4-digit numbers. This has the significant disadvantage that the information collected is erased as soon as the browser tab is closed. So we do not recommend it except in cases where any data storage is not permissible.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>How we use data</h4>
      <p>
        We do not share any of your data with anyone else. The only personal information collected is that which you explicitly provide -- we do not collect personal information 'behind the scenes' while you use this app.  We may contact account holders via email from time to time with information regarding your account. No advertising companies collect data through this app.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>No error-free performance</h4>
      <p>
        We do not guarantee error-free performance under this Privacy Policy. We will use reasonable efforts to comply with this Privacy Policy and will take prompt corrective action when we learn of any failure to comply with our Privacy Policy. We shall not be liable for any incidental, consequential, or punitive damages relating to this Privacy Policy. This Privacy Policy hall be governed by the laws of the State of North Carolina and the United States, to the extent applicable.
      </p>
    </div>
    <div className="aa-review-row">
      <h4>We are not "HIPAA compliant"</h4>
      <p>
        Users are solely responsible for any applicable compliance with federal or state laws governing the privacy and security of personal data, including medical or other sensitive data. We specifically disclaim any representation or warranty that the software, as offered, complies with the federal Health Insurance Portability and Accountability Act (“HIPAA”). We do not sign “Business Associate Agreements,” and you agree that KPR is not a Business Associate or subcontractor or agent of yours pursuant to HIPAA. If you have questions about the security of your data, please contact accessnavigator@aac-learning-center.org.    
      </p>
    </div>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function StaticPrivacy(props) {

  const pageData = {
    image: "",
    faIcon: "", //fa-user",
    majorHeading: "Access Navigator Privacy Policy",
    title: ``,
    subTitle: "",
    learnMore: {linkText: "",
                title: "",
                content: ""
                },
    nextRoute: "", 
    continueDisabled: true, //we'll only use the Back button on these static pages
    sidebar: false
  }

  console.log("Rendering Privacy page");
  
  return(
    <>
    <Body page={pageData} contentComponent={<StaticPrivacyContent />} />
    </>
  );
}


export default StaticPrivacy;